import { duration } from "html2canvas/dist/types/css/property-descriptors/duration";
import { genericRequest, isolatedScanRoute } from "./service";
import { IsolatedScan } from "../types/starAPIResponseTypes";

/**
 * Gets metadata for isolated scans related to a given section.
 * 
 * @param sectionScanId of the isolated scans metadata to fetch
 * 
 * @returns metadata for all isolated scans in the section
 */
export const getIsolatedScan = async (sectionScanId: number): Promise<IsolatedScan[] | Error> => {
  return await genericRequest({ url: `${isolatedScanRoute}/section/${sectionScanId}`, method: "GET" })
}

/**
 * Gets transcribed voice note.
 * 
 * @param isolated_scan_id of voice note to transcribe
 * 
 * @returns transcribed voicenote
 */
export const getVoiceNoteText = async (isolated_scan_id: number) => {
  return await genericRequest({ url: `${isolatedScanRoute}/${isolated_scan_id}/voice-notes/transcriptions`, method: "GET" })
}

/**
 * Updates an isolated scans voice note transcription text.
 * 
 * @param isolatedScan to update
 * @param updatedTranscriptText to update
 * 
 * @returns request response
 */
export const updateVoiceNoteTranscript = async (isolatedScan: IsolatedScan, updatedTranscriptText: string) => {
  if (isolatedScan.voice_note_transcript_json === undefined) { return }
  const transcriptJson = JSON.parse(isolatedScan.voice_note_transcript_json)

  let edits = [updatedTranscriptText]
  // if ("edits" in transcriptJson) {
  //   edits = [...[updatedTranscriptText], ...transcriptJson["edits"]]
  // }
  const updatedTranscript = {...transcriptJson, edits: edits}

  const body = JSON.stringify({
    voice_note_transcript_json: JSON.stringify(updatedTranscript),
  })

  return await genericRequest({ url: `${isolatedScanRoute}/${isolatedScan.isolated_scan_id}`, method: "PUT", body: body})
}